import * as React from 'react';

import Calendar16 from './Calendar16';

export const calendar16 = () => <Calendar16 />;

export default {
    title: 'Icon/Fill/Calendar16',
    component: Calendar16,
    parameters: {
        notes: "`import Calendar16 from 'box-ui-elements/es/icon/fill/Calendar16';`",
    },
};
